import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const token = params.get('token') || '';
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided');
      return;
    }

    const verify = async () => {
      try {
        const res = await fetch(`/api/auth/verify-email?token=${token}`);
        const data = await res.json();
        if (data.success) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully!');
        } else {
          setStatus('error');
          setMessage(data.error || isRTL ? 'فشل التحقق' : 'Verification failed');
        }
      } catch {
        setStatus('error');
        setMessage('Verification failed. Please try again.');
      }
    };
    verify();
  }, [token]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #FAF8F4 0%, #F0EDE6 100%)', padding: 20,
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '48px 40px', maxWidth: 460, width: '100%',
        boxShadow: '0 8px 32px rgba(60,54,50,0.1)', textAlign: 'center',
      }}>
        {/* Gold accent bar */}
        <div style={{ height: 3, background: 'linear-gradient(90deg, #B8943A, #CCA94E, #B8943A)', borderRadius: '16px 16px 0 0', margin: '-48px -40px 32px', }} />

        {status === 'loading' && (
          <>
            <div style={{
              width: 48, height: 48, border: '3px solid #E6E2DA', borderTopColor: '#B8943A',
              borderRadius: '50%', margin: '0 auto 20px',
              animation: 'spin 1s linear infinite',
            }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
            <h1 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 22, fontWeight: 700, color: '#2E2A26' }}>{isRTL ? "جاري التحقق من بريدك الإلكتروني..." : "Verifying your email..."}</h1>
            <p style={{ fontFamily: "'Sora', system-ui, sans-serif", fontSize: 14, color: '#8B8178', marginTop: 8 }}>{isRTL ? "يرجى الانتظار لحظة." : "Please wait a moment."}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{
              width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg, #EFF5E6, #E6F0D8)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px', fontSize: 28, boxShadow: '0 4px 12px rgba(122,140,82,0.15)',
            }}>
              ✅
            </div>
            <h1 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 26, fontWeight: 700, color: '#2E2A26', marginBottom: 8 }}>
              Email Verified!
            </h1>
            <p style={{ fontFamily: "'Sora', system-ui, sans-serif", fontSize: 14, color: '#8B8178', lineHeight: 1.7, marginBottom: 28 }}>
              Your account is now active. You can log in and start your ITIL certification journey.
            </p>
            <Link to="/login" style={{
              display: 'inline-block', padding: '14px 32px', borderRadius: 10,
              background: 'linear-gradient(135deg, #B8943A, #CCA94E)',
              color: '#2E2A26', fontWeight: 700, fontSize: 14, textDecoration: 'none',
              fontFamily: "'Sora', system-ui, sans-serif",
              boxShadow: '0 4px 12px rgba(184,148,58,0.3)',
            }}>
              Log In Now
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{
              width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg, #FFF3E0, #FFE8CC)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px', fontSize: 28, boxShadow: '0 4px 12px rgba(184,92,58,0.15)',
            }}>
              ⚠️
            </div>
            <h1 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 26, fontWeight: 700, color: '#2E2A26', marginBottom: 8 }}>
              Verification Failed
            </h1>
            <p style={{ fontFamily: "'Sora', system-ui, sans-serif", fontSize: 14, color: '#8B8178', lineHeight: 1.7, marginBottom: 28 }}>
              {message}
            </p>
            <Link to="/login" style={{
              display: 'inline-block', padding: '12px 28px', borderRadius: 10,
              border: '1.5px solid #E6E2DA', background: 'transparent',
              color: '#2E2A26', fontWeight: 600, fontSize: 13, textDecoration: 'none',
              fontFamily: "'Sora', system-ui, sans-serif",
            }}>
              Go to Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
